import React from 'react';
import { FaHighlighter, FaPencilAlt } from 'react-icons/fa';
import './HighlightToggle.css';

interface HighlightToggleProps {
  isEnabled: boolean;
  onToggle: () => void;
}

const HighlightToggle: React.FC<HighlightToggleProps> = ({ isEnabled, onToggle }) => {
  const handleClick = () => {
    onToggle();
  };

  return (
    <button
      className={`highlight-toggle ${isEnabled ? 'active' : ''}`}
      onClick={handleClick}
      title={isEnabled ? 'Disable Highlight' : 'Enable Highlight'}
    >
      {isEnabled ? <FaHighlighter /> : <FaPencilAlt />}
    </button>
  );
};

export default HighlightToggle;